import React, { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import Navigation from "../components/Navigation";

const CurrencyDetailScreen = () => {
  const navigate = useNavigate();
  const { symbol } = useParams();
  const [timeFrame, setTimeFrame] = useState("1M");
  const [loading, setLoading] = useState(false);

  // Mock crypto data
  const cryptoData = {
    symbol: symbol,
    name:
      symbol === "BTC"
        ? "Bitcoin"
        : symbol === "ETH"
        ? "Ethereum"
        : symbol === "BNB"
        ? "Binance Coin"
        : symbol === "SOL"
        ? "Solana"
        : symbol === "ADA"
        ? "Cardano"
        : symbol === "DOT"
        ? "Polkadot"
        : "Cryptocurrency",
    currentPrice:
      symbol === "BTC"
        ? "$43,567.89"
        : symbol === "ETH"
        ? "$2,345.67"
        : symbol === "BNB"
        ? "$312.45"
        : symbol === "SOL"
        ? "$98.76"
        : symbol === "ADA"
        ? "$0.45"
        : symbol === "DOT"
        ? "$7.89"
        : "$0.00",
    change: "+$1,234.56",
    changePercent: "+2.92%",
    marketCap: "$856.2B",
    volume: "28.5B",
    circulatingSupply: "19.5M",
    maxSupply: "21M",
    allTimeHigh: "$69,045.00",
    allTimeLow: "$67.81",
  };

  const timeFrames = ["1D", "5D", "1M", "3M", "6M", "1Y", "5Y", "MAX"];

  const cryptoInfo = {
    description:
      "Bitcoin is a decentralized digital currency, without a central bank or single administrator, that can be sent from user to user on the peer-to-peer bitcoin network without intermediaries.",
    technology: "Blockchain",
    consensus: "Proof of Work",
    blockTime: "10 minutes",
    totalSupply: "21,000,000",
    circulatingSupply: "19,500,000",
  };

  const keyMetrics = [
    { label: "Market Cap", value: cryptoData.marketCap },
    { label: "24h Volume", value: cryptoData.volume },
    { label: "Circulating Supply", value: cryptoData.circulatingSupply },
    { label: "Max Supply", value: cryptoData.maxSupply },
    { label: "All Time High", value: cryptoData.allTimeHigh },
    { label: "All Time Low", value: cryptoData.allTimeLow },
  ];

  return (
    <div className="screen">
      {/* Header with back button */}
      <div className="card">
        <div className="card-header">
          <button
            onClick={() => navigate(-1)}
            className="btn btn-outline btn-small"
          >
            ← Back
          </button>
          <div>
            <h2 className="card-title">{cryptoData.name}</h2>
            <div className="card-subtitle">{cryptoData.symbol}</div>
          </div>
        </div>
      </div>

      {/* Price Information */}
      <div className="card">
        <div className="text-center">
          <div
            style={{
              fontSize: "3rem",
              fontWeight: "bold",
              color: "#E5E7EB",
              marginBottom: "8px",
            }}
          >
            {cryptoData.currentPrice}
          </div>
          <div
            className={`stock-change ${
              cryptoData.changePercent.startsWith("+") ? "positive" : "negative"
            }`}
            style={{ fontSize: "1.2rem" }}
          >
            {cryptoData.change} ({cryptoData.changePercent})
          </div>
        </div>
      </div>

      {/* Chart Placeholder */}
      <div className="card">
        <div className="card-header">
          <h3 className="card-title">Price Chart</h3>
          <div className="flex gap-2">
            {timeFrames.map((frame) => (
              <button
                key={frame}
                onClick={() => setTimeFrame(frame)}
                className={`btn ${
                  timeFrame === frame ? "" : "btn-outline"
                } btn-small`}
              >
                {frame}
              </button>
            ))}
          </div>
        </div>
        <div
          style={{
            height: "400px",
            background: "#2A2A2A",
            borderRadius: "8px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            color: "#94A3B8",
          }}
        >
          📈 Price chart for {cryptoData.symbol} ({timeFrame}) will be displayed
          here
        </div>
      </div>

      {/* Key Metrics */}
      <div className="card">
        <div className="card-header">
          <h3 className="card-title">Key Metrics</h3>
        </div>
        <div className="grid-3">
          {keyMetrics.map((metric, index) => (
            <div key={index} className="portfolio-card">
              <div className="portfolio-value">{metric.value}</div>
              <div className="portfolio-label">{metric.label}</div>
            </div>
          ))}
        </div>
      </div>

      {/* Cryptocurrency Information */}
      <div className="card">
        <div className="card-header">
          <h3 className="card-title">About {cryptoData.name}</h3>
        </div>
        <div className="grid-2">
          <div>
            <h4 style={{ color: "#E5E7EB", marginBottom: "12px" }}>
              Technical Details
            </h4>
            <div style={{ color: "#94A3B8", lineHeight: "1.6" }}>
              <div>
                <strong>Technology:</strong> {cryptoInfo.technology}
              </div>
              <div>
                <strong>Consensus:</strong> {cryptoInfo.consensus}
              </div>
              <div>
                <strong>Block Time:</strong> {cryptoInfo.blockTime}
              </div>
              <div>
                <strong>Total Supply:</strong> {cryptoInfo.totalSupply}
              </div>
              <div>
                <strong>Circulating:</strong> {cryptoInfo.circulatingSupply}
              </div>
            </div>
          </div>
          <div>
            <h4 style={{ color: "#E5E7EB", marginBottom: "12px" }}>
              Description
            </h4>
            <div style={{ color: "#94A3B8", lineHeight: "1.6" }}>
              {cryptoInfo.description}
            </div>
          </div>
        </div>
      </div>

      {/* Trading Actions */}
      <div className="card">
        <div className="card-header">
          <h3 className="card-title">Trading Actions</h3>
        </div>
        <div className="grid-2">
          <button
            onClick={() =>
              navigate("/add-investment", {
                state: { symbol: cryptoData.symbol, name: cryptoData.name },
              })
            }
            className="btn btn-large"
          >
            💰 Buy {cryptoData.symbol}
          </button>
          <button
            onClick={() =>
              navigate("/add-transaction", {
                state: {
                  symbol: cryptoData.symbol,
                  name: cryptoData.name,
                  type: "sell",
                },
              })
            }
            className="btn btn-error btn-large"
          >
            📉 Sell {cryptoData.symbol}
          </button>
          <button
            onClick={() =>
              navigate("/add-transaction", {
                state: {
                  symbol: cryptoData.symbol,
                  name: cryptoData.name,
                  type: "buy",
                },
              })
            }
            className="btn btn-outline btn-large"
          >
            ➕ Add Transaction
          </button>
          <button
            onClick={() => navigate("/market")}
            className="btn btn-outline btn-large"
          >
            📊 View Market
          </button>
        </div>
      </div>

      {/* Market Sentiment */}
      <div className="card">
        <div className="card-header">
          <h3 className="card-title">Market Sentiment</h3>
        </div>
        <div className="grid-3">
          <div className="portfolio-card">
            <div className="portfolio-value" style={{ color: "#22C55E" }}>
              Bullish
            </div>
            <div className="portfolio-label">Sentiment</div>
          </div>
          <div className="portfolio-card">
            <div className="portfolio-value">72%</div>
            <div className="portfolio-label">Fear & Greed</div>
          </div>
          <div className="portfolio-card">
            <div className="portfolio-value">High</div>
            <div className="portfolio-label">Volatility</div>
          </div>
        </div>
      </div>

      {/* News Placeholder */}
      <div className="card">
        <div className="card-header">
          <h3 className="card-title">Latest News</h3>
        </div>
        <div
          style={{
            height: "200px",
            background: "#2A2A2A",
            borderRadius: "8px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            color: "#94A3B8",
          }}
        >
          📰 Latest news about {cryptoData.symbol} will be displayed here
        </div>
      </div>

      <Navigation />
    </div>
  );
};

export default CurrencyDetailScreen;
